module.exports = __webpack_public_path__ + "img/a-ziyuan3.092d76d1.png";